<hbo-datatable-smart *ngIf="fitErrors$ | async as fitErrors"
  [typeData]="'fits'" [entities_filter]="entities_filter"
  [types_filter]="types_filter" [prevDynamoKey]="prevDynamoKey" [lastDynamoKey]="lastDynamoKey"
  [pages]="dynamoPaginationService.currentFitPaginationValue"
  [columns]="columns"
  [items]="fitErrors" (reload)="searchFitError($event)"
  [showDateFilter]="true"
  [paginationType]="'dynamo'"
>
  <tbody class="table-group-divider accordion" id="accordionFitError">
    <ng-container *ngFor="let fitError of fitErrors.data">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse-' + fitError.code_measure"> </button></th>
        <td *ngIf="user.roleId !== 4">{{ setCrossShop(fitError.shop_id) }}</td>
        <td>{{ fitError.shop_id }}</td>
        <td>{{ fitError.TagID }}</td>
        <td>
          <div class="input-group w-75">
            <input type="text" class="form-control" placeholder="Your Reference" [(ngModel)]="fitError.internalRef">
            <button type="button" *ngIf="user.profileId !== 2" class="btn btn-outline-secondary" (click)="updateFitReference(fitError)">{{ 'COMMON.SAVE' | translate }}</button>
          </div>
        </td>
        <td>{{ fitError.local_date | date:'yyyy/MM/dd HH:mm' }}</td>
        <td>{{ fitError.date | date:'yyyy/MM/dd HH:mm' }}</td>
      </tr>
      <tr class="row-body">
        <td [attr.colspan]="user.roleId !== 4 ? 7 : 6" class="bg-light p-0">
          <div [id]="'collapse-' + fitError.code_measure" class="accordion-collapse collapse" data-bs-parent="#accordionFitError">
            <div class="accordion-body">
              <div class="row p-4">
                <div class="col-6 position-relative">
                  <ng-container *ngIf="fitError.internalRef">
                    <h5 class="border-bottom border-dark pb-2 mb-3">Error Type</h5>
                    <p>{{ fitError.internalRef }}</p>
                  </ng-container>
                  <button type="button" class="btn btn-outline-secondary position-absolute bottom-0" (click)="getTar(fitError)">
                    <i class="bi bi-download"></i> Tar Measure
                  </button>
                </div>
                <div class="col-5 offset-1">
                  <div class="input-group mb-4">
                    <input type="text" class="form-control" placeholder="Your comment" [(ngModel)]="fitError.comments">
                    <button *ngIf="user.profileId !== 2" type="button" class="btn btn-outline-secondary" (click)="updateFitComments(fitError)">{{ 'COMMON.SAVE' | translate }}</button>
                  </div>
                  <img [src]="madeForYouImageUrl + fitError.code_measure | request | async" alt="measure" class="w-100" (error)="handleMissingImage($event)">
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!fitErrors.data.length">
      <td colspan="6" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>
